module.exports = __webpack_public_path__ + "img/office-pay.a4a03f34.png";